

const Error =()=>{
    return (
        <>

        </>
    )
}

export default Error